import './style/index.scss'
import { Game } from './core/Game/index'
import { GameViewer } from './core/Viewer/GameViewer'

new Game(new GameViewer())
